import {
  buildClientNutritionPlanDocPath,
  buildClientNutritionPlanMealDocPath,
  buildClientNutritionPlanMealsCollectionPath,
  buildClientNutritionPlansCollectionPath,
  buildClientNutritionRootDocPath,
  buildPendingClientNutritionPlanDocPath,
  buildPendingClientNutritionPlanMealDocPath,
  buildPendingClientNutritionPlanMealsCollectionPath,
  buildPendingClientNutritionPlansCollectionPath,
  buildPendingClientNutritionRootDocPath,
} from "../Firestore/nutrition/nutritionPaths";
import { shouldUsePendingBlockPath, resolvePendingWorkspaceDocPath } from "./clientBlockPathResolver";
import { buildPendingWorkspaceStatePatch } from "./pendingWorkspaceState";

const normalizeTrimmedValue = (value) =>
  typeof value === "string" ? value.trim() : "";

export const shouldUsePendingNutritionPath = (client) =>
  shouldUsePendingBlockPath(client) === true;

export function resolveClientNutritionWorkspace(clientOrUserId) {
  const client =
    clientOrUserId && typeof clientOrUserId === "object" ? clientOrUserId : null;

  if (client && shouldUsePendingNutritionPath(client)) {
    const coachId = normalizeTrimmedValue(client?.coach?.id);
    const pendingUserId = normalizeTrimmedValue(client?.pendingUserId);

    if (!coachId || !pendingUserId) {
      return null;
    }

    return {
      scope: "pending",
      scopeKey: `pending:${coachId}:${pendingUserId}`,
      coachId,
      userId: "",
      pendingUserId,
      rootDocPathSegments: buildPendingClientNutritionRootDocPath(
        coachId,
        pendingUserId,
      ),
      plansCollectionPathSegments: buildPendingClientNutritionPlansCollectionPath(
        coachId,
        pendingUserId,
      ),
      workspaceDocPathSegments: resolvePendingWorkspaceDocPath(client),
      buildPlanDocPath: (planId) =>
        buildPendingClientNutritionPlanDocPath(coachId, pendingUserId, planId),
      buildPlanMealsCollectionPath: (planId) =>
        buildPendingClientNutritionPlanMealsCollectionPath(
          coachId,
          pendingUserId,
          planId,
        ),
      buildPlanMealDocPath: (planId, mealId) =>
        buildPendingClientNutritionPlanMealDocPath(
          coachId,
          pendingUserId,
          planId,
          mealId,
        ),
      buildWorkspaceMetadataPatch: ({ lastUpdate } = {}) =>
        buildPendingWorkspaceStatePatch({
          client,
          lastUpdate,
        }),
    };
  }

  const userId = normalizeTrimmedValue(client?.id ?? clientOrUserId);
  if (!userId) {
    return null;
  }

  return {
    scope: "active",
    scopeKey: `client:${userId}`,
    coachId: "",
    userId,
    pendingUserId: "",
    rootDocPathSegments: buildClientNutritionRootDocPath(userId),
    plansCollectionPathSegments: buildClientNutritionPlansCollectionPath(userId),
    workspaceDocPathSegments: null,
    buildPlanDocPath: (planId) => buildClientNutritionPlanDocPath(userId, planId),
    buildPlanMealsCollectionPath: (planId) =>
      buildClientNutritionPlanMealsCollectionPath(userId, planId),
    buildPlanMealDocPath: (planId, mealId) =>
      buildClientNutritionPlanMealDocPath(userId, planId, mealId),
    buildWorkspaceMetadataPatch: () => null,
  };
}

export function resolveClientNutritionPlanDocPath(clientOrUserId, planId) {
  return resolveClientNutritionWorkspace(clientOrUserId)?.buildPlanDocPath?.(planId) ?? null;
}

export function resolveClientNutritionPlanMealsCollectionPath(clientOrUserId, planId) {
  return (
    resolveClientNutritionWorkspace(clientOrUserId)?.buildPlanMealsCollectionPath?.(
      planId,
    ) ?? null
  );
}

export function resolveClientNutritionPlanMealDocPath(clientOrUserId, planId, mealId) {
  return (
    resolveClientNutritionWorkspace(clientOrUserId)?.buildPlanMealDocPath?.(
      planId,
      mealId,
    ) ?? null
  );
}
